'use client'

import { SendMock } from '../feature-mocks/SendMock'
import { useSendJourney } from './SendJourneyContext'
import { HERO_PHASE, HERO_TILT_DEG } from './constants'

/**
 * Hero collage anchor for the send journey. Renders SendMock in place when the
 * journey is inactive; when active it stays as an invisible measuring target
 * and the provider's floating SendMock covers it.
 */
export function HeroSendSlot() {
  const journey = useSendJourney()
  const enabled = journey?.enabled ?? false
  return (
    <div ref={journey?.heroSlotRef} style={{ position: 'absolute', top: 0, left: 0, right: 20 }}>
      <div
        aria-hidden={enabled || undefined}
        style={{
          transform: `rotate(${HERO_TILT_DEG}deg)`,
          visibility: enabled ? 'hidden' : 'visible'
        }}>
        <SendMock phase={enabled ? HERO_PHASE : undefined} />
      </div>
    </div>
  )
}
